import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { StyledDialog, StyledDialogTitle } from "../../main_components/material_table/styles/general_form_styles";

interface GeneralModalProps {
    title: string;
    component: React.ReactNode;
    open: boolean;
    onClose: () => void;
    size?: "xs" | "sm" | "md" | "lg" | "xl";
}

const CUSTOM_DIALOG: React.FC<GeneralModalProps> = ({ title, component, open, onClose, size = "lg" }) => {
    return (
        <StyledDialog open={open} maxWidth={size} fullWidth>
            <StyledDialogTitle>
                {title}
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{ position: 'absolute', right: 8, top: 8, color: 'white' }}
                >
                    <CloseIcon />
                </IconButton>
            </StyledDialogTitle>
            {component}
        </StyledDialog>
    );
};

export default CUSTOM_DIALOG;




